// extracted by mini-css-extract-plugin
var _1 = "src-components-ForgotPasswordForm-_TextDialog__dialogCloseButton--_8RyWoRSmJ7ugj6WSioS";
var _2 = "src-components-ForgotPasswordForm-_TextDialog__dialogCloseButtonWrapper--NrVrevJsYb4YbFaYGnqQ";
var _3 = "src-components-ForgotPasswordForm-_TextDialog__dialogText--RUYBioFLrv1MpNepGYfm";
var _4 = "src-components-ForgotPasswordForm-_TextDialog__textDialog--YWPleO6Ep9hvQmtwAK9O";
export { _1 as "dialogCloseButton", _2 as "dialogCloseButtonWrapper", _3 as "dialogText", _4 as "textDialog" }
